import { render, staticRenderFns } from "./simple-action-button.vue?vue&type=template&id=37ef808d&scoped=true"
import script from "./simple-action-button.vue?vue&type=script&lang=js"
export * from "./simple-action-button.vue?vue&type=script&lang=js"
import style0 from "./simple-action-button.vue?vue&type=style&index=0&id=37ef808d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef808d",
  null
  
)

export default component.exports